import React from "react"
import parse from "html-react-parser"
import { updateCDNUrls } from "aldoo-ra/Blog/Editor"

/**
 * Renders a help center category note with different display options
 * @param {Object} props
 * @param {Object} props.note - The note object
 * @param {string} props.note.content - HTML content of the note
 * @param {string} props.note.renderas - How to render the note (top_direct, bottom_direct, top_bubble, bottom_bubble)
 */
const HCCategoryNote = ({ note }) => {
  if (!note || !note.content) return null

  // Parse content from HTML string

  const parsedContent = parse(updateCDNUrls(note.content))

  // Determine the rendering style based on the renderas property
  const renderStyle = note.renderas || "bottom_direct"
  const [position, style] = renderStyle.split("_")

  // Render content based on style
  const renderContent = () => {
    if (style === "bubble") {
      return (
        <div className="text-text bg-orange_lt rounded-[30px] py-5 pl-5 pr-[30px] mb-8">
          {parsedContent}
        </div>
      )
    } else {
      // Direct style
      return <div className="my-4">{parsedContent}</div>
    }
  }

  return renderContent()
}

export default HCCategoryNote
